<template>
  <component-wrapper>
    <grid-container-fi
      :class="{
        'text-quote-fi': true,
        'text-quote-fi--dark': fields.dark?.value,
      }"
    >
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-3 md:fi-col-end-11">
        <quote-fi :fields="fields" />
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import QuoteFi from 'components/quote-fi/QuoteFi';
import ssrOnlyMixin from 'mixins/ssrOnlyMixin';

export default {
  name: 'TextQuoteFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    QuoteFi,
  },
  mixins: [ssrOnlyMixin],
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped lang="scss">
@import './text-quote-fi';
</style>
